export default {
    created: "Logul webhook WhatsApp a fost creat cu succes.",
    updated: "Logul webhook WhatsApp a fost actualizat cu succes.",
    deleted: "Logul webhook WhatsApp a fost sters cu succes.",
    restored: "Logul webhook WhatsApp a fost restaurat cu succes.",
}
